import { DcaStrategySummaryRes } from "src/store/features/api/generated";
import { useDcaSlice } from "src/store/features/dca.slice";
import { useUserSlice } from "src/store/features/user.slice";
import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";

export default function useSummaryConfig() {
  const { summary } = useDcaSlice();
  const { defaultTradeFee } = useUserSlice();

  const {
    endDate,
    startDate,
    totalTriggers,
    totalValue,
    frequency,
    buy: {
      currencyConfig: { code: buyToken },
      value: buyValue,
    },
    sell: {
      currencyConfig: { code: sellToken },
    },
    spendLimit,
    nextOrderDifference,
  } = summary as DcaStrategySummaryRes;

  const isToday = startDate
    ? new Date(startDate).toDateString() === new Date().toDateString()
    : false;

  const stringStartDate = startDate ? dateFormatter(startDate) : "";
  const stringEndDate = endDate ? dateFormatter(endDate) : "";
  const numberOfOrders = totalTriggers ? JSON.stringify(totalTriggers) : "";
  const todayOrFutureLower = isToday ? "today" : stringStartDate;
  const todayOrFutureCapital = isToday ? "Today" : stringStartDate;

  const dcaContent = `${formatCurrency(
    buyValue,
    sellToken,
  )} of ${buyToken} every ${frequency.toLocaleLowerCase()} starting ${todayOrFutureLower}`;

  const summaryDetails = [
    {
      label: "DCA",
      content: dcaContent,
    },
    { label: "Broker Fee", content: `${defaultTradeFee}%` },
    { label: "You receive", content: `` },
    { label: "Spend Limit", content: `${spendLimit ?? ""}` },
    {
      label: "No. of Orders",
      content: numberOfOrders,
    },
    { label: "Start date", content: todayOrFutureCapital },
    { label: "End date", content: stringEndDate },
  ];

  return { startDate, summaryDetails, nextOrderDifference, totalValue, sellToken, frequency };
}
